var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHydration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_376_33229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D8EAF9",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.275 32C26.475 31.9833 26.6458 31.9042 26.7875 31.7625C26.9292 31.6208 27 31.45 27 31.25C27 31.0167 26.925 30.8292 26.775 30.6875C26.625 30.5458 26.4333 30.4833 26.2 30.5C25.5167 30.55 24.7917 30.3625 24.025 29.9375C23.2583 29.5125 22.775 28.7417 22.575 27.625C22.5417 27.4417 22.4542 27.2917 22.3125 27.175C22.1708 27.0583 22.0083 27 21.825 27C21.5917 27 21.4 27.0875 21.25 27.2625C21.1 27.4375 21.05 27.6417 21.1 27.875C21.3833 29.3917 22.05 30.475 23.1 31.125C24.15 31.775 25.2083 32.0667 26.275 32V32M26 35C23.7167 35 21.8125 34.2167 20.2875 32.65C18.7625 31.0833 18 29.1333 18 26.8C18 25.1333 18.6625 23.3208 19.9875 21.3625C21.3125 19.4042 23.3167 17.2833 26 15C28.6833 17.2833 30.6875 19.4042 32.0125 21.3625C33.3375 23.3208 34 25.1333 34 26.8C34 29.1333 33.2375 31.0833 31.7125 32.65C30.1875 34.2167 28.2833 35 26 35V35M26 33C27.7333 33 29.1667 32.4125 30.3 31.2375C31.4333 30.0625 32 28.5833 32 26.8C32 25.5833 31.4958 24.2083 30.4875 22.675C29.4792 21.1417 27.9833 19.4667 26 17.65C24.0167 19.4667 22.5208 21.1417 21.5125 22.675C20.5042 24.2083 20 25.5833 20 26.8C20 28.5833 20.5667 30.0625 21.7 31.2375C22.8333 32.4125 24.2667 33 26 33V33M26 25V25V25V25V25V25V25V25V25V25",
    fill: "#004276"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_376_33229",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_376_33229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_376_33229",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydration);
export default __webpack_public_path__ + "static/media/hydration.ae89291ef45374cb092bca35ac1d5783.svg";
export { ForwardRef as ReactComponent };